//# sourceMappingURL=role.mjs.map
/// <reference types="./role.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $order from "../../../gleam_stdlib/gleam/order.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Role extends $CustomType {
  constructor(id, name) {
    super();
    this.id = id;
    this.name = name;
  }
}
export const Role$Role = (id, name) => new Role(id, name);
export const Role$isRole = (value) => value instanceof Role;
export const Role$Role$id = (value) => value.id;
export const Role$Role$0 = (value) => value.id;
export const Role$Role$name = (value) => value.name;
export const Role$Role$1 = (value) => value.name;

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "name",
        $decode.string,
        (name) => { return $decode.success(new Role(id, name)); },
      );
    },
  );
}

export function encode(role) {
  return $json.object(
    toList([["id", $json.string(role.id)], ["name", $json.string(role.name)]]),
  );
}

function seniority(role) {
  if (role === "Super Admin") {
    return 0;
  } else if (role === "Admin") {
    return 1;
  } else if (role === "Proposal Manager") {
    return 2;
  } else if (role === "Content Curator") {
    return 3;
  } else if (role === "Contributor") {
    return 4;
  } else {
    return 5;
  }
}

/**
 * Order roles by seniority rather than alphabetically, so a list of them
 * reads the way the product talks about them. This ranking is ours, not
 * Auth0's — it only ever lived in the Management client by accident.
 * An unknown name sorts last rather than failing.
 */
export function compare(r1, r2) {
  return $int.compare(seniority(r1.name), seniority(r2.name));
}
